import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { apiPaths } from "../../../../../service/apiPaths";
import ApiService from "../../../../../service/ApiService";
import { ILeaveRequest } from "../../Leave.props";

const useAddLeaveRequest = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState<ILeaveRequest>({
    description: "",
    fromDate: today,
    toDate: today,
    type: "single",
    subtype: "full",
  });

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, type: value as "single" | "multiple" };
      if (value === "multiple") {
        newData.subtype = "full";
      }
      return newData;
    });
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "fromDate" && prev.type === "single") {
        newData.toDate = value;
      }
      return newData;
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await ApiService({
        method: "POST",
        endpoint: apiPaths.createLeaveRequest,
        data: formData,
      });
      toast.success("Leave request submitted successfully");
      navigate("/leave");
    } catch (error: any) {
      toast.error(
        error.response.data.error || "Failed to submit leave request"
      );
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/leave");
  };

  return {
    loading,
    formData,
    handleChange,
    handleSubmit,
    handleCancel,
    handleTypeChange,
    handleDateChange,
  };
};

export default useAddLeaveRequest;
